import { RiBuilding2Line } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/atoms/Select";
import { routePaths } from "@/config/route-paths";
import { useGetTenants } from "@/features/tenant-management/api/get-tenants";

/**
 * テナント管理へ戻るための値。テナント ID は ULID なので衝突しない。
 */
const TENANT_MANAGEMENT = "__tenant-management__";

/**
 * ホストが見ているテナントを切り替える。
 *
 * 同じ画面のまま相手を変える。テナントを変えるたびに一覧へ戻すと、
 * 複数テナントを見て回る運営の動きに合わない。
 *
 * テナントの中ではサイドバーが作業画面に置き換わるため、運営者の世界へ戻る
 * 導線がここしか無い。末尾にテナント管理への項目を置く。
 */
export const TenantSwitcher = ({ tenantId }: { tenantId: string }) => {
  const { tenants } = useGetTenants();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const handleChange = (nextValue: string) => {
    if (nextValue === TENANT_MANAGEMENT) {
      void navigate(routePaths.admin.tenants.getHref());
      return;
    }
    if (nextValue === tenantId) {
      return;
    }
    // パス中のテナント ID だけを差し替える。1 つ目のセグメントに限る
    void navigate(`${pathname.replace(tenantId, nextValue)}${search}`);
  };

  return (
    <Select value={tenantId} onValueChange={handleChange}>
      <SelectTrigger aria-label="テナントを切り替える" className="w-64">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {tenants.map((tenant) => (
          <SelectItem key={tenant.tenantId} value={tenant.tenantId}>
            {tenant.name}
          </SelectItem>
        ))}

        <div className="my-1 border-t border-gray-200" role="presentation" />

        <SelectItem value={TENANT_MANAGEMENT}>
          <span className="inline-flex items-center gap-2 text-gray-600">
            <RiBuilding2Line size={16} />
            テナント管理
          </span>
        </SelectItem>
      </SelectContent>
    </Select>
  );
};
